import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';
import { InitNewService } from '../models/REQ/initNewService';
import { PersonGeneralInfo } from '../models/REQ/personGeneralInfo';

@Injectable({
    providedIn: 'root'
})
export class SIESPServicesService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.SIESPServices;
  jsonHeaders = { headers: { 'Content-Type': 'application/json' } }

  public GetSIESPServicesByCognitoUser(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetSIESPServicesByCognitoUser`);
  }

  public GetSIESPService(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/GetSIESPService`, dataId, this.jsonHeaders);
  }

  public CreateSIESPService(data: InitNewService): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/CreateSIESPService`, data);
  }

  public Save(data: PersonGeneralInfo): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Save`, data);
  }

  public Disable(data: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Disable`, data);
  }

  public SendToSIES(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/SendToSIES`, dataId, this.jsonHeaders);
  }

  public ResendToSIES(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/ResendToSIES`, dataId, this.jsonHeaders);
  }

  public GetMVXServiceResult(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/GetMVXServiceResult`, dataId, this.jsonHeaders);
  }
}